import React, { useEffect, useState, useRef } from 'react';
import FabricPurchaseContractDeliveryScheduleService from '../../services/fabric-contract-delivery-schedule.service';
import './fabric-purchase-contract-delivery-schedule-list.scss';
import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
} from '@syncfusion/ej2-react-grids';
import moment from 'moment'
import HardDelete from '../hard-delete/hard-delete';
import securityService from '../security/security.service';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import CommonService from '../../services/common.service';
import SecurityService from '../security/security.service';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import AuditTableInput from '../audit-table/audit-table';
var selectedRows = [];

export default function FabricContractDeliveryScheduleList(props) {
  console.log(props);
  const [yarnContracts, setYarnContracts] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

    const [deleteDialogVisibility, setDeleteDialogVisibility] = useState(false);
  const [dialogWarningVisibility, setDialogWarningVisibility] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const deleteDialog = useRef();
  const warningDialog = useRef();
  const [deletingID, setDeletingID] = useState(0);
  const [showDialogs, setShowDialogs] = useState();
  const [deletingProps, setDeletingProps] = useState();

  let deliveryScheduleGrid: Grid;

  useEffect(() => {
    // const type = getRoute()[1];
    getYarnContractDeliverySchedule();
  }, []);

  const toolbarOptions: ToolbarItems[] = [
    'Add',
    'Edit',
    {
      text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !SecurityService.canUserAccess('FabricPurchaseContractDeliveryScheduleDelete')
    },
    'Update',
    'Cancel',
  ];

  // const databound = () =>
  // {
  //     if (deliveryScheduleGrid) {
  //       deliveryScheduleGrid.autoFitColumns();
  //     }
  // }


  const getYarnContractDeliverySchedule = async () => {
    console.log("Fabric Delivery Schedule", props)
    if(props?.FabricContractID) {
    // props.YarnContractID
    FabricPurchaseContractDeliveryScheduleService.get(props?.FabricContractID)
      .then((response) => {
        console.log(response);
        setYarnContracts(response.data.recordset);
      })
      .catch((e) => {
        console.log(e);
      });
    }
    
  };

//   const thousandSeperator = (field: string, data: object, column: Column) => {
//     const value = data[column.field];
//     console.log(value);
//     if (value) {
//         let parts = value.toString().split('.');
//         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//         return parts.join('.');
//     }
// }

  const getRoute = () =>
    window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/');

  const actionComplete = (args: DialogEditEventArgs) => {
    if (args.requestType === 'save' && args.action === 'add') { 
      // console.log('data: ', args);
      const schedule = {
        //OrderID: props.OrderID,
        // TODO: Confirm if this is right?
        FabricContractID: props.FabricContractID,
        DeliveryMonth: moment(args.data.DeliveryMonth).format('YYYY-MM-DD'),
        DeliveryQuantity: args.data.DeliveryQuantity,
        UserID: userId,
      };
      console.log('schedule : ', schedule);
      FabricPurchaseContractDeliveryScheduleService.insert(schedule)
        .then((response) => {
          console.log(response);
          getYarnContractDeliverySchedule();
          let AddData = {
            DeliveryQuantity:args.data.DeliveryQuantity,
            DeliveryMonth:moment(args.data.DeliveryMonth).format('YYYY-MM-DD')
         
          }
          AuditTableInput.auditAdd(`FabricContract - DeliverySchedule`,`FabricContract_DeliverySchedule`,`FabricContractDeliveryScheduleID`,AddData)

        })
        .catch((e) => {
          console.log(e);
        });
    }
    if (args.requestType === 'save' && args.action === 'edit') { 
      // console.log('data: ', args);
      const schedule = {
        //OrderID: props.OrderID,
        // TODO: Confirm if this is right?
        FabricContractID: props.FabricContractID,
        DeliveryMonth: moment(args.data.DeliveryMonth).format('YYYY-MM-DD'),
        DeliveryQuantity: args.data.DeliveryQuantity,
        UserID: userId,
      };
      console.log('schedule : ', schedule);
      FabricPurchaseContractDeliveryScheduleService.update(args.data.FabricContractDeliveryScheduleID
        ,schedule)
        .then((response) => {
          console.log(response);
          getYarnContractDeliverySchedule();
          let EditData = {
            DeliveryQuantity:args.data.DeliveryQuantity,
            DeliveryMonth:moment(args.data.DeliveryMonth).format('YYYY-MM-DD')
         
          }
          let totalColumns = Object.keys(EditData);
          console.log(totalColumns)
          let SelectedRowData = {
            ...selectedRows,
            DeliveryMonth:moment(selectedRows.DeliveryMonth).format('YYYY-MM-DD')
          }
          console.log(totalColumns,selectedRows,EditData,`FabricContract_DeliverySchedule`,args.data.FabricContractDeliveryScheduleID)
          AuditTableInput.auditEdit(totalColumns,SelectedRowData,EditData,`FabricContract_DeliverySchedule`,args.data.FabricContractDeliveryScheduleID)
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const editSettings: EditSettingsModel = {
    allowEditing: SecurityService.canUserAccess('FabricPurchaseContractDeliveryScheduleEdit'),
    allowAdding: SecurityService.canUserAccess('FabricPurchaseContractDeliveryScheduleAdd'),
    allowDeleting: SecurityService.canUserAccess('FabricPurchaseContractDeliveryScheduleDelete'),
    mode: 'Normal',
    showDeleteConfirmDialog: true,
  };

  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
  };

  const sortingOptions: SortSettingsModel = {
    columns: [{ field: 'DeliveryMonth', direction: 'Ascending' }]
  }

  const toolbarClick = (args: ClickEventArgs) => {
    // console.log('args.item.properties :', args);
    if (deliveryScheduleGrid && args.item.properties.id === 'Delete') {
      console.log('toolbar Delete');
      if (deliveryScheduleGrid.selectedRowIndex === -1) {
        // no rows selected
        console.log('Delete ', deliveryScheduleGrid.getSelectedRecords()[0]);
        // setDialogWarningVisibility(false);
        // ', '', ''
        let obj={
          TableName:`FabricContract_DeliverySchedule`,
          ColumnName:`FabricContractDeliveryScheduleID`,
          RowID:undefined,
          SelectedRow:false,
          UserID:userId,
          SelectedRowData:{
          DeliveryQuantity:deliveryScheduleGrid.getSelectedRecords()[0].DeliveryQuantity,
          DeliveryMonth:moment(deliveryScheduleGrid.getSelectedRecords()[0].DeliveryMonth).format('YYYY-MM-DD'),
         
         
      }
          // DeleteSecurity:`ProcessDescDelete`
          
        }
        setDeletingProps(obj)
        setShowDialogs(true)
       
      } else {
        console.log('delete: ', deliveryScheduleGrid.getSelectedRecords()[0]?.FabricContractDeliveryScheduleID)
        // deleteDialog.current.hide();
        let obj={
          TableName:`FabricContract_DeliverySchedule`,
          ColumnName:`FabricContractDeliveryScheduleID`,
          RowID:deliveryScheduleGrid.getSelectedRecords()[0]?.FabricContractDeliveryScheduleID,
          SelectedRow:true,
          UserID:userId,
          SelectedRowData:{
            DeliveryQuantity:deliveryScheduleGrid.getSelectedRecords()[0].DeliveryQuantity,
            DeliveryMonth:deliveryScheduleGrid.getSelectedRecords()[0].DeliveryMonth,
           
           
        }
          // DeleteSecurity:`FabricContractDeliveryScheduleDelete`
          
          }
          setDeletingProps(obj)
        
        // deleteDialog.current.show();
        setShowDialogs(true)
      }
    } 
  };

  const monthValidationRules = {
    required: true,
    date: true,
  };

  const balanceBags = (yarnContracts) => {
    console.log('fabric');
    // get all rows and calculate the total
    return 2000;
  };

  const quantityValidationRules = {
    required: true,
   // number: true,
    max: balanceBags(),
  };


  const dialogClose = () => {
    this.buttonInstance.style.display = 'inline-block';
    setShowDialog(false);
  };

  

      const userId = securityService.getLoggedInUserId();

      const thousandSeperator = (field: string, data: object, column: Column) => {
        const value = data[column.field];
        console.log(value);
        if (value) {
            let parts = value.toString().split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return parts.join('.');
        }
    }

    const Sum = (e: any) => {
        return <span> {e.Sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</span>;
    };
    const footerSum = (e: any) => {
        return <span> Sum: {e.Sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</span>;
    };
  return (
    <div className='delivery-schedule-container'>
      <div className='row'>
        <div className='col'>
          <label>Order ID:</label>
        </div>
        <div className='col'>
          <label>{props.OrderID}</label>
        </div>
      </div>

      <div className='row'>
        <div className='col'>
          <label>Order Date:</label>
        </div>
        <div className='col'>
          <label>{moment(props?.OrderDate).format('DD/MM/YY')}</label>
        </div>
      </div>

      <div className='row'>
        <div className='col'>
          <label>Company Name:</label>
        </div>
        <div className='col'>
          <label>{props.CompanyName}</label>
        </div>
      </div>

      {/* <div className='row'>
        <div className='col'>
          <label>Fabric Count:</label>
        </div>
        <div className='col'>
          <label>{props.FullYarnCount}</label>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <label>Fabric Brand:</label>
        </div>
        <div className='col'>
          <label>{props.BrandName}</label>
        </div>
      </div> */}
      <div className='row'>
        <div className='col'>
          <label>Bags Ordered:</label>
        </div>
        <div className='col'>
          <label>{Number(props.OrderQuantity).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</label>
        </div>
      </div>

      <br />
      <div>
      {showDialogs ?
          <HardDelete
            {...deletingProps} 
            showResult={(e)=>{
                                console.log(e)

                                setShowDialogs(false)
                                if(e == false){
                                  setShowDialogs(false)
                                  getYarnContractDeliverySchedule()
                                }
              }} 
                ></HardDelete>
                  :null}
            </div>
      <GridComponent
        ref={(grid) => (deliveryScheduleGrid = grid)}
        id='yarnContractDeliveryScheduleGrid'
        dataSource={yarnContracts}
        editSettings={editSettings}
        toolbar={toolbarOptions}
        pageSettings={{ pageCount: 4, pageSizes: true, pageSize: 5 }}
        filterSettings={filterOptions}
        actionComplete={actionComplete}
        allowTextWrap='true'
        allowPaging={true}
        allowSorting={true}
        allowPdfExport={true}
        allowExcelExport={true}
        toolbarClick={toolbarClick}
        allowFiltering={true}
        showColumnChooser={true}
        allowReordering={true}
        sortSettings={sortingOptions}
        // dataBound={databound}
        rowSelected={
          (args)=>{
            console.log(args.data)
          if(selectedRows.length == 0){

          
             return selectedRows = args.data
          }  
            
                      setTimeout(() => {
              console.log('ss')
            }, 200);
          }
        }
      >
        <ColumnsDirective>
          <ColumnDirective
            headerText='Order ID'
            field='FabricContractID'
            width='120'
            textAlign='Left'
            visible={false}
          />
          <ColumnDirective
            headerText='Month'
            field='DeliveryMonth'
            width='25'
            type='date'
            format='dd/MM/yy'
            textAlign='Right'
            editType='datepickeredit'
            validationRules={monthValidationRules}
          />
          <ColumnDirective
            headerText='Quantity'
            field='DeliveryQuantity'
            width='25'
            textAlign='Right'
            editType='numericedit'
            valueAccessor={thousandSeperator}
           // validationRules={quantityValidationRules}
          />
          <ColumnDirective
            headerText='FabricContractDelilveryScheduleID'
            field='FabricContractDelilveryScheduleID'
            width='200'
            visible={false}
          />
        </ColumnsDirective>
        <Inject
          services={[Edit, Toolbar, Page, Sort, Filter, Aggregate, Reorder, Resize]}
        />
            <AggregatesDirective>

<AggregateDirective>
    <AggregateColumnsDirective>

        <AggregateColumnDirective
            field='DeliveryQuantity'
            type='Sum'
            footerTemplate={footerSum}
            // valueAccessor={thousandSeperator}
        />

    </AggregateColumnsDirective>
</AggregateDirective>
</AggregatesDirective>
      </GridComponent>
    </div>
  );
}
